import classNames from 'classnames';
import { HTMLRenderer } from 'common/html-renderer.js';
import { IMapSlotClose } from 'common/tile/tile-body-header-v2-element.js';
import { GenericMarkerDescription } from 'components-modules/map-slot-generic';
import { IModule } from 'redux-state/layout/types.js';
import { moduleHasTitle } from 'utilities/layout.js';

export interface IHTMLRendererModuleProps {
  /** We added string arrays here on request as long lines pf html can be a nightmare to manage */
  content?: string | Array<string>;
}

export const HTMLModule = ({ isDrawer, modulePath, config }: IModule<IHTMLRendererModuleProps & IMapSlotClose>) => {
  const { content } = config;

  return (
    <GenericMarkerDescription
      key={config.key}
      dataModule="html-renderer-slot"
      config={config}
      modulePath={modulePath}
      isDrawer={isDrawer}
    >
      <HTMLRenderer
        classes={classNames({ 'u-mT-responsive': moduleHasTitle({ isDrawer, config }) })}
        content={content}
        trackingOrigin={config.title || 'html_module'}
      />
    </GenericMarkerDescription>
  );
};
